const AuthEvent = {
  TOKEN_REFRESHED: 'authTokenRefreshed',
};

export default AuthEvent;
